import { render } from "./ZabbixProblems.vue?vue&type=template&id=7628cb78&scoped=true"
import script from "./ZabbixProblems.vue?vue&type=script&lang=js"
export * from "./ZabbixProblems.vue?vue&type=script&lang=js"

import "./ZabbixProblems.vue?vue&type=style&index=0&id=7628cb78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7628cb78"]])

export default __exports__